export const topBarHeight = 64
export const sideNavWidth = 260
export const drawerWidth = 600
export const navbarHeight = 60
export const sidenavCompactWidth = 80
export const containedLayoutWidth = 1200
export const MAXIMUM_DATE_PERIOD = 90
export const BASE_URL = process.env['NODE_ENV'] === 'development' ? 'http://localhost:5256' : '';
export const REPORT_BASE_URL = process.env['NODE_ENV'] === 'development' ? 
                                'https://reportviewer.shenukdistributors.com/web/viewer.html' : 
                                'https://reportviewer.shenukdistributors.com/web/viewer.html';
export const CONFLICT_STATUS_CODE = 409;
export const VALIDATION_STATUS_CODE = 422;
export const NOT_FOUND = "/not-found";
export const HTTP_STATUS = {
    IDLE: "idle",
    LOADING: "loading",
    SUCCEEDED: "succeeded",
    FAILED: "failed"
}
export const NAME_VALIDATION = /^\S[a-zA-Z0-9-&%\s]+\S$/;
export const NAME_VALIDATION_MZG = "should contain numbers, letters, dashes and spaceses only";
export const NAME_VALIDATION_CAPITAL_LETTERS = /^\S[A-Z0-9-]+\S$/;
export const NAME_VALIDATION_MZG_CAPITAL_LETTERS = "should contain numbers, capital letters, dashes only";
export const NAME_VALIDATION_NOT_SPACES = /^[a-zA-Z0-9-&%]+$/;
export const NAME_VALIDATION_MZG_NOT_SPACES = "should contain numbers, letters and dashes only";
export const HTTP_EX_MZG = "Something Went Wrong Please Contact System Administrator";
export const TABLE_PAGE_SIZE = [10, 20, 50, 100];
export const Bottle_doz = 12;
export const PayableAccId = 2;
export const CAPACITY_MEASURMENT = {
    0: "ML ( Milliliter )",
    1: "G ( Gram )",
    2: "KG ( kilogram )",
    3: "MG ( Milligram )",
    4: "L ( Liter )"
}

export const CAPACITY_MEASURMENT_CONVERT = {
    0: "ML",
    1: "G",
    2: "KG",
    3: "MG",
    4: "L"
}

export const VEHICAL_TYPES = {
    0: "INHOUSE VEHICAL",
    1: "TEMPORARY VEHICAL"
}

export const EMPLOYEE_TYPE = {
    0: "INHOUSE EMPLOYEE",
    1: "TEMPORARY EMPLOYEE"
}

export const STOCK_ADJESTMENT = {
    0: "ADD",
    1: "REMOVE"
}

export const WAREHOUSE = {
    0: "RD",
    1: "PRI",
    2: "OUTLET",
    3: "DAMAGE"
}

export const WAREHOUSE_OPPOSIT = {
    "RD": 0,
    "PRI": 1,
    "OUTLET": 2,
    "DAMAGE": 3
}

export const RETURN_TYPE = {
    0: "EXPIRED",
    1: "GOODS"
}

export const TR_TYPE = {
    0: "CREDIT",
    1: "DEBIT"
}

export const TR_TYPE_OPPOSIT = {
    "CREDIT": 0,
    "DEBIT": 1
}

export const CHEQUE_STATUS = {
    CREATED : -1,
    PENDING : 0,
    BANKED: 1,
    RETURNED: 2,
    CHANGED: 3,
    CANCELLED: 4
}

export const CHEQUE_STATUS_OPPOSE = {
    "-1" : "CREATED",
    0: "PENDING",
    1: "BANKED",
    2: "RETURNED",
    3: "CHANGED",
    4: "CANCELLED"
}

export const CHEQUE_STATUS_COLOR = {
    CREATED: "info",
    PENDING: "primary",
    BANKED: "secondary",
    RETURNED: "error",
    CHANGED: "success",
    CANCELLED: "warning"
}

export const STOCK_EXISTANCE =
{
    STOCK_EXIST : 0,
    STOCK_NOTEXIST: 1
}

export const CREDIT_COLLECTED_BY = {
    0: "CASH",
    1: "CHEQUE",
    3: "BANK"
}

export const CREDIT_COLLECTED_BY_OPPOSE = {
    "CASH": 0,
    "CHEQUE": 1,
    "BANK": 3
}

export const CREDIT_CREATED_AS = {
    0: "CASH",
    2: "CREDIT",
    3: "BANK",
    4: "DEBIT"
}

export const CREDIT__CREATED_AS_OPPOSE = {
    "CASH": 0,
    "CREDIT": 2,
    "BANK": 3,
    "DEBIT": 4
}

export const BOTTLE_RETURN_TYPE = {
    0: "BOTTLE",
    1: "LOAN",
    2: "PURCHASE",
    3: "DAMAGE"
}

export const BOTTLE_RETURN_TYPE_OPPOSE = {
    BOTTLE: 0,
    LOAN: 1,
    PURCHASE: 2,
    DAMAGE: 3
}

export const CHEQUE_STATUS_FILTER = [
    {id: 1, label: "Banked"}, 
    {id: 2, label: "Returned"}, 
    {id: 3, label: "Changed"},
    {id: 4, label: "Canceled" }
]

export const DISCOUNT_GIVEN_BY = {
    0: "N/A",
    1: "CASH",
}

export const DISCOUNT_GIVEN_BY_OPPOS = {
    "N/A" : 0,
    "CASH" : 1
}

export const ACCOUNT_TYPES = {
    Asset: 1,
    Liability: 2,
    Equity: 3,
    Revenue: 4,
    Expense: 5
}

export const ACCOUNT_TYPES_OPPOS = {
    1: "Asset",
    2: "Liability",
    3: "Equity",
    4: "Revenue",
    5: "Expense"
}

export const ACCOUNT_TYPE_BALANCE = {
    Asset: 1,
    Liability: 0,
    Equity: 0,
    Revenue: 0,
    Expense: 1
}

export const CHEQUE_TYPES = [
    { id: 1, label: "Receivables" },
    { id: 2, label: "Payable"}
]

export const EXPENSE_PAYMENT_SOURCE = {
    1: "PENDING",
    2: "DRAFTED",
    3: "APPROVED"
}

export const EXPENSE_PAYMENT_SOURCE_OPPOSE = {
    "PENDING" : 1,
    "DRAFTED": 2,
    "APPROVED": 3
}

export const EXPENSE_DRAFT_PAYMENT_SOURCE = {
    1: "PENDING",
    2: "HALF PAID",
    3: "FULL PAID"
}

export const EXPENSE_DRAFT_PAYMENT_SOURCE_OPPOSE = {
    "PENDING" : 1,
    "HALF_PAID": 2,
    "FULL_PAID": 3
}

export const EXPENSE_TRACK = [
    { id: 1, label: "Payable", disabled: false },
    { id: 2, label: "History", disabled: false},
    { id: 3, label: "Payable History", disabled: true }
]

export const EEPENSE_STATUS_COLOR = {
    1: "primary",
    2: "secondary",
    3: "success",
    4: "primary",
    5: "primary"
}

export const TRANSACTION_TYPE_COLOR = {
    DEBIT: "error",
    CREDIT: "success"
}

export const CREDIT_MARGIN_BY = [
    { id: 1, label: "%" },
    { id: 2, label: "+"}
]

export const CREDIT_MARGIN_INDEX = {
    1: 0,
    2: 1
}

export const INCOME_VS_SALES = [
    {  id: 1, label: "SALES" },
    {  id:2, label: "INCOME" }
]

export const EXPENDITURE_TYPE = [
    { id: "EXPENDITURE", label: "EXPENDITURE" },
    {id: "PETTY_CASH", label: "PETTY CASH"}
]

export const EXPENDITURE = [
    { id: 1, label: "EXPENDITURE" },
    {id: 2, label: "PETTY CASH"}
]

export const EXPENDITURE_MAP = {
    1: "EXPENDITURE",
    2: "PETTY CASH"
}

export const EXPENDITURE_MAP_OPPOSE = {
    "EXPENDITURE": 1,
    "PETTY CASH": 2
}

export const EXPENDITURE_ACC_TYPE = [
    { id: 3, label: "OPERATING" },
    {id: 4, label: "NON OPERATING"}
]

export const EXPENDITURE_ACC_TYPE_OPPOS = {
    3: "OPERATING",
    4: "NON OPERATING"
}

export const ASSET_ACC_TYPE_OPPOS =  {
    1: "CURRENT",
    2: "NON CURRENT"
}

export const EXPENDITURE_ACC_TYPE_MAP = {
    OPERATING: 3,
    NON_OPERATING: 4
}

export const EXP_MENU_TYPE = {
    "EXP" : 0,
    "DRFT": 1
}

export const PAYMENTS = [
    { id: 1, label: "CASH" },
    { id: 2, label: "BANK" },
    { id: 3, label: "CHEQUE" }
]

export const ACC_TYPE_CURRENT = {
    CURRENT: 1,
    NON_CURRENT: 2
}

export const AccountCategory = {
    1: "Current",
    2: "Non_current",
    3: "Operating",
    4: "Non_operating",
    5: ""
}

export const LedgerOptions = [
    'Add Account',
    'Vew Ledger',
    'Delete Account'
];

export const EquityCat = 5

export const AccountPayableId = 200000;
export const SalesRevenueId = 400000;
export const SalesReturnId = 400002;
export const COGSID = 500000;
export const TaxID = 500006;
export const PETTY_CASH_HOLDER = 200002;
export const mainBanlAccountsId = 100006;
export const cashAccount = 100003;
export const PETTY_CASH_ACCOUNT = 100004;

export const ATTENDANCE_EMPLOYEE_TYPE_OPTIONS = [
    { id: 0, label: 'Admin' },
    { id: 1, label: 'Non-Admin' },
];

export const ATTENDANCE_STATUSES = ['Present', 'Absent', 'HalfDay', 'Leave'];

export const WORKFORCE_TIER_OPTIONS = [
    { value: 'Admin',      label: 'Admin (Office & Management Staff)' },
    { value: 'Semi-Admin', label: 'Semi-Admin (Field & Sales Executives)' },
    { value: 'Non-Admin',  label: 'Non-Admin (Operational Personnel)' },
];